
//Dragscroll

function dragscroll(el){
    var cursorYPos, cursorXPos, cursorDown, elScrollLeft, elScrollTop;

    el.className += " has-dragscroll";

    el.addEventListener('mousemove', function(e){
        //console.info("mousemove",e.pageX,e.pageY)
        if(cursorDown){
            el.scrollLeft = elScrollLeft + (cursorXPos - e.pageX);
            el.scrollTop = elScrollTop + (cursorYPos - e.pageY);
        }
    });

    el.addEventListener('mousedown', function(e){
        cursorYPos = e.pageY;
        cursorXPos = e.pageX;
        elScrollLeft = el.scrollLeft;
        elScrollTop = el.scrollTop;
        cursorDown = true;
        //console.info("down",cursorXPos,cursorYPos)
    });

    el.addEventListener('mouseup', function(e){
        cursorDown = false;
        //console.info("up",cursorXPos,cursorYPos)
    });
}
